import React from "react";
import './Bestofmonth.css';

const Bestofmonth =(props) =>{
    return(
        <section id="Browse bikes by">
        <h4 class="text-center mt-4 text1" > Best bikes of September 2022</h4>
        <div class=" Container ">
            <div class="w-75  col1">
                <div class="card text-center">
                    <div class="card-header">
                        <ul class="nav nav-tabs  card-header-tabs">
                        <li class="nav-item bliw1">
                            <a class="nav-link active" aria-current="true" href="#">Scooters</a>
                        </li>
                        <li class="nav-item bliw1">
                            <a class="nav-link disabled" href="#">Commuter</a>
                        </li>
                        <li class="nav-item bliw1">
                            <a class="nav-link disabled" href="#">Sports</a>
                        </li>
                        <li class="nav-item bliw1">
                            <a class="nav-link disabled" href="#">Cruisers</a>
                        </li>
                        <li class="nav-item bliw1">
                            <a class="nav-link disabled" href="#" >Electric</a>
                        </li>
                        </ul>
                    </div>
                    <div class="card-body">
                        <div class="card-group p-1">
                            <div class="card m-2">
                                <img src="https://mohit6795.github.io/Bikewale-Bootstrap/feature%20or%20best%20bikes%20img/ray-right-front-three-quarter-2.webp" class="card-img-top" alt="..."/>
                                <div class="card-body">
                                    <h5 class="bikename">Yamaha Ray ZR</h5>
                                    <p class="shortspecification">125 cc, 8.04 bhp, 98kg</p>
                                    <div>
                                        <span class="pricetitle">Avg. Ex-showroom price</span>
                                        <span class="onlineprice">₹ 82,247</span>
                                    </div>
                                    <span class="font14">onwards</span> 
                                    <div>
                                        <button class="pricebtn">Check on-road price</button>
                                    </div>
                                </div>
                            </div>

                            <div class="card m-2">
                                <img src="https://mohit6795.github.io/Bikewale-Bootstrap/feature%20or%20best%20bikes%20img/450x-gen-3-right-front-three-quarter.webp" class="card-img-top" alt="..."/>
                                <div class="card-body">
                                    <h5 class="bikename">Ather 450X Gen 3</h5>
                                    <p class="shortspecification">124.8 cc, 9.25 bhp, 118kg</p>
                                    <span class="pricetitle">Avg. Ex-showroom price</span>
                                    <div>
                                        <span class="onlineprice">₹ 83,779</span>
                                        <span class="font14">onwards</span>
                                    </div> 
                                    <div>
                                        <button class="pricebtn">Check on-road price</button>
                                    </div>                                
                                </div>
                            </div>

                            <div class="card m-2">
                                <img src="https://mohit6795.github.io/Bikewale-Bootstrap/feature%20or%20best%20bikes%20img/ntorq-125-right-front-three-quarter.webp" class="card-img-top" alt="..."/>
                                <div class="card-body">
                                    <h5 class="bikename ">TVS Ntorq 125</h5>
                                    <p class="shortspecification">124.8 cc, 9.25 bhp, 118kg</p>
                                    <span class="pricetitle">Avg. Ex-showroom price</span>
                                    <div>
                                        <span class="onlineprice">₹ 83,779</span>
                                        <span class="font14">onwards</span>
                                    </div>                             
                                    <div>
                                        <button class="pricebtn">Check on-road price</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-grid gap-2 col-3 mx-auto w-50">
                        <a href="listpage.html"><button type="button" class="btn btn-outline-warning mb-2 view-all-target-btn ">View more Brands</button></a>
                    </div> 
                </div>
            </div>
        </div>
    </section>
    )
}
    export default Bestofmonth;